import ExpandCollapse from './ExpandCollapse';
import Accordion from './Accordion';
import Panel from './Panel';
ExpandCollapse.Panel = Panel;
Accordion.Panel = Panel;
export default ExpandCollapse;
export { Accordion };